<p-dialog header="Relationship" [(visible)]="displayRelationship" [modal]="true" [closable]="false"
    [style]="{width: '60vw'}" (onHide)="closeDialog()">
    <div class="card">
      <p-table [value]="relationship" responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th>Child Account</th>
                <th class="action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" (onChange)="checkAllAccess()"
                    [(ngModel)]="hasAccessAll" binary="true"></p-checkbox>
                  Access
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-relation>
            <tr>
                <td>{{relation.sequenceNumber}} - {{relation.name}}</td>
                <td>
                  <p-checkbox [ngModelOptions]="{standalone: true}" (onChange)="changeAllAccess()"
                    [(ngModel)]="relation.hasAccess" binary="true"></p-checkbox>
                </td>
            </tr>
        </ng-template>
      </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayRelationship=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="saveRelationship()"></button>
    </p-footer>
</p-dialog>